import { MonitorSubscriberBadge } from "../subscriberPills/MonitorSubscriberBadge";
import { NotificationLevelType } from "@avenueops/shared-types";
import { Badge } from "@avenueops/web-components";

interface Props {
  notificationLevel: NotificationLevelType;
  notificationIndex: number;
  hasDefaultOnly: boolean;
}

export function MonitorSubscriberNotificationLevel({ notificationLevel, notificationIndex, hasDefaultOnly }: Props) {
  return (
    <>
      {!hasDefaultOnly ? (
        <div className="col-span-2 self-start font-medium text-gray-700 w-fit whitespace-nowrap">
          {notificationIndex === 0 ? "On creation" : `If escalated ${notificationIndex} time${notificationIndex > 1 ? "s" : ""}`}
        </div>
      ) : null}
      <div
        className="col-span-8 flex flex-wrap data-[notDefault=true]:border border-gray-200 rounded data-[notDefault=true]:p-1 gap-2 overflow-auto"
        data-notDefault={!hasDefaultOnly}
      >
        {notificationLevel.recipients.map((recipient: any, index: number) => (
          <MonitorSubscriberBadge recipient={recipient} key={index} />
        ))}
        {notificationLevel.recipients.length === 0 ? (
          <Badge type="CUSTOM" className="bg-white">
            None
          </Badge>
        ) : null}
      </div>
    </>
  );
}
